<template>
    <div class="j-import-wrap">
        <el-dialog :title="title" custom-class="j-import-dialog" top="15%" :visible.sync="dialogVisible" :close-on-click-modal="false" @close="closeDialog" width="300px">
            <div class="j-import-dialog-step">
                <div class="j-import-dialog-step-title"><i>1</i><span>下载excel模板</span></div>
                <div class="j-import-dialog-step-desc" style="padding-bottom: 28px;"><el-button @click="downloadTemplate">下载模板</el-button></div>
            </div>
            <div class="j-import-dialog-step">
                <div class="j-import-dialog-step-title"><i>2</i><span>编辑模板文件</span></div>
                <div class="j-import-dialog-step-desc" style="padding-bottom: 28px;">使用本地office软件打开模板文件</div>
            </div>
            <div class="j-import-dialog-step">
                <div class="j-import-dialog-step-title"><i>3</i><span>上传编辑好的文件</span></div>
                <div class="j-import-dialog-step-desc">
                    <el-upload ref="upload" :headers="headers" :action="action" :accept="mimeTypeLimit.join(',')" :before-upload="handleCheck" :on-success="handleSuccess" :on-error="handleError" :limit="1" :show-file-list="true" :data="postData" :auto-upload="autoUpload">
                        <el-button>上传文件</el-button>
                    </el-upload>
                </div>
            </div>
            <div v-if="!autoUpload" slot="footer" class="j-import-dialog-footer">
                <el-button type="info" @click="closeDialog">取消</el-button>
                <el-button type="primary" :loading="submitLoad" @click="importEvent">导入</el-button>
            </div>
        </el-dialog>
        <el-dialog title="导入结果" :visible.sync="dialogResult" :close-on-click-modal="false" @close="closeResult" width="800px" top="10%">
            <el-table :data="errorTable" size="mini" height="400px">
                <el-table-column v-for="(columnProp, index) in columnProps" :key="index" :prop="columnProp" :label="columnNames[index]" :formatter="columnPropFormatter" align="center" show-overflow-tooltip />
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
    import { fls } from '@/config'
    export default {
        name: 'JImport',
        props: {
            mimeTypeLimit: { // mimeType数组限制,仅能上传数组中限定的文件类型
                type: Array,
                default: () => []
            },
            sizeLimit: { // 上传文件大小限制(MB)
                type: Number,
                default: 0
            },
            autoUpload: {
              type: Boolean,
              default: false
            },
            title: {
                type: String,
                default: '导入向导'
            },
            template: {
                type: String,
                required: true
            },
            tables: { // 错误列表字段
                type: Array,
                default: () => ['errorInfo', 'replicationInfo']
            },
            columnProps: { // 错误字段绑定属性
              type: Array,
              default: () => ['name,title', 'errorMsg,error']
            },
            columnNames: { // 错误字段绑定中文名
              type: Array,
              default: () => ['名称', '错误原因']
            },
            action: { // 可配置的文件上传接口地址
                type: String,
                default: `${fls}/api/files`
            },
            postData: {
                type: Object,
                default: () => ({})
            },
            headers: {
                type: Object,
                default: () => ({})
            }
        },
        data () {
            return {
                dialogVisible: true,
                dialogResult: false,
                submitLoad: false,
                errorTable: [],
                resultData: {}
            }
        },
        methods: {
            importEvent () {
              if (this.submitLoad) return
              this.submitLoad = true
              this.$refs.upload.submit()
            },
            handleCheck (file) {
                let mimeType = true
                let size = true
                if (this.mimeTypeLimit.length > 0 && !this.mimeTypeLimit.includes(file.type)) mimeType = false
                if (this.sizeLimit > 0 && (file.size / 1024 / 1024) > this.sizeLimit) size = false
                if (!mimeType) {
                    this.$message.error(`上传文件允许格式:${this.mimeTypeLimit.join(',')}`)
                }
                if (!size) {
                    this.$message.error(`上传文件大小不能超过 ${this.sizeLimit}MB`)
                }
                return mimeType && size
            },
            handleSuccess (data) {
                if (data.status !== 'yes') return this.handleError(data)
                this.resultData = data.data
                this.errorTable = []
                this.tables.forEach(listName => {
                    let list = data.data[listName]
                    if (list && Array.isArray(list) && list.length > 0) this.errorTable.push(...list)
                })
                if (this.errorTable.length > 0) {
                    // 包含错误消息
                    this.dialogResult = true
                } else {
                    this.$message.success('数据导入完成')
                    this.closeDialog()
                }
                this.$emit('import-complete')
                this.$refs.upload.clearFiles()
                this.submitLoad = false
            },
            columnPropFormatter (row, cell) {
                const { property } = cell
                let rowValue = '-'
                property.split(',').some(prop => {
                    if (row[prop]) {
                        rowValue = row[prop]
                        return true
                    }
                })
                return rowValue
            },
            handleError (err) {
                const { msg, message } = err
                console.warn(msg || message || '文件导入异常')
                this.$message && this.$message.error(msg || message || '文件导入异常')
                this.$emit('import-error', err)
                this.submitLoad = false
            },
            downloadTemplate () {
                if (this.submitLoad) return
                this.submitLoad = true
                const a = document.createElement('a')
                a.href = `/template/${this.template}`
                a.click()
                a.remove()
                this.submitLoad = false
            },
            closeDialog () {
                this.$emit('update:close', false)
            },
            closeResult () {
                this.dialogResult = false
                this.closeDialog()
            }
        }
    }
</script>

<style lang="scss">
    .j-import-wrap {
        .j-import-dialog {
            .j-import-dialog-step {
                margin-left: 7px;
                border-left: 2px solid rgba(57, 76, 155, .08);
                padding-left: 23px;
                &:first-child {
                    margin-top: 6px;
                }
                .j-import-dialog-step-title {
                    position: relative;
                    font-size: 14px;
                    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
                    font-weight: normal;
                    color: #326cc3;
                    line-height: 18px;
                    margin-bottom: 4px;
                    > i {
                        display: flex;
                        position: absolute;
                        left: -33px;
                        align-items: center;
                        justify-content: center;
                        height: 18px;
                        line-height: 18px;
                        width: 18px;
                        border-radius: 50%;
                        color: rgba(29, 62, 110,.6);
                        font-style: normal;
                        box-sizing: border-box;
                        border: 2px solid rgba(46, 128, 252, 1);
                        font-size: 12px;
                    }

                }
                .j-import-dialog-step-desc {
                    font-size: 13px;
                    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
                    font-weight: normal;
                    color: rgba(46, 128, 252,0.6000);
                    line-height: 20px;
                }
            }
        }
    }
</style>
